// Run `fn` once the DOM is parsed. Every module needs this, and the bundle sits
// in Webflow's page footer, so `loading` is the common case but not the only one
// -- an async or deferred load can land after DOMContentLoaded has fired.
export function onReady(fn) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fn, { once: true });
  } else {
    fn();
  }
}
